import React from 'react';

import {AaSequenceAlignment} from 'constants/AlignmentConstants';
import {
  getAminoAcidMatrix,
  getIdenticalSites,
  getLength,
  getNumMatchingPairs,
  getNumNonGapPairs,
  getNumAaSequences,
  getPairwisePercentIdentity,
} from 'molbio/aa-sequences/alignments/AaSequenceAlignmentStatsUtil';
import {getNonConsensusRows} from 'molbio/aa-sequences/alignments/AaSequenceAlignmentUtil';

const AaSequenceAlignmentStats = (props: {
  alignment: AaSequenceAlignment;
  selectionStart: number;
  selectionEnd: number | null;
}): JSX.Element => {
  const aminoAcidMatrix = getAminoAcidMatrix(
    getNonConsensusRows(props.alignment),
    props.selectionStart,
    props.selectionEnd
  );
  const pairwiseIdentity = Math.round(
    getPairwisePercentIdentity(getNumMatchingPairs(aminoAcidMatrix), getNumNonGapPairs(aminoAcidMatrix))
  );
  return (
    <div className="aaSequenceAlignmentStats">
      <div className="aaSequenceAlignmentStats-text-container">
        <div>
          <strong>Alignment Statistics</strong>
        </div>
        <div>
          Length: {getLength(aminoAcidMatrix)}
          <br />
          Number of AA Sequences: {getNumAaSequences(aminoAcidMatrix)}
          <br />
          Identical Sites: {getIdenticalSites(aminoAcidMatrix)}
          <br />
          Pairwise Identity: {`${pairwiseIdentity}%`}
        </div>
      </div>
    </div>
  );
};

export default AaSequenceAlignmentStats;
